/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type MuxUploadStatusDto = {
  /**
   * 업로드 상태
   */
  status: MuxUploadStatusDto.status;
  /**
   * MUX Asset ID (업로드 완료 시)
   */
  assetId?: string;
  /**
   * MUX Playback ID (Asset 준비 완료 시)
   */
  playbackId?: string;
};
export namespace MuxUploadStatusDto {
  /**
   * 업로드 상태
   */
  export enum status {
    WAITING = "waiting",
    ASSET_CREATED = "asset_created",
    ERRORED = "errored",
    CANCELLED = "cancelled",
    TIMED_OUT = "timed_out",
  }
}
